export default __webpack_public_path__ + "static/media/tehran-uni-logo.ac55427e.png";